<template>
    <section class="page1">
        <div class="bg"></div>
        <div class="arrow bounce animate__animated animate__fadeIn animate__delay-2s" :class="{ hideit: scrolled }"  v-scroll-to="'.page1'"></div>

        <div class="main">
            <div class="text-left column-text">
                <p
                    class="text-big text-grey text-bold Roboto"
                    data-aos="fade-up"
                    data-aos-delay="200"
                >
                    A LGPD garante que todo o tratamento de dados pessoais respeite os direitos fundamentais de liberdade e de privacidade. Veja abaixo o que isso significa:
                </p>
                <div class="article flex-row text-center p2">
                    <div class="icons">
                        <div class="breakpoint p1">
                            <img
                                src="~@/assets/img/page1-ico0.png"
                                alt=""
                                data-aos="fade-right"
                                data-aos-delay="400"
                            />
                            <p
                                class="p2"
                                data-aos="fade-up"
                                data-aos-delay="600"
                            >
                                Para uma empresa ter acesso às informações de uma pessoa, ao qual a base definida para o
                                tratamento de dados pessoais tenha
                                sido o Consentimento, será preciso o seu aceite a respeito de como os dados serão
                                tratados.
                            </p>
                        </div>
                    </div>
                    <div class="icons">
                        <div class="breakpoint p1">
                            <img
                                src="~@/assets/img/page1-ico1.png"
                                alt=""
                                data-aos="fade-left"
                                data-aos-delay="400"
                            />
                            <p
                                class="p2"
                                data-aos="fade-up"
                                data-aos-delay="800"
                            >
                                Neste exemplo, a pessoa poderá solicitar, a qualquer momento, a revogação do
                                consentimento e a exclusão dos seus dados pessoais.
                            </p>
                        </div>
                    </div>
                </div>
                <p class="p3" data-aos="fade" data-aos-delay="1100">
                   A lei <span class="text-bold">já entrou em vigor</span>, com punições pela Autoridade Nacional de Proteção de Dados (ANPD) a partir de agosto de 2021 e, como você pode ver, essa autonomia tem impacto direto em processos rotineiros do RH.
                </p>
                <!-- <div
                    class="article-blue text-white text-bold m1"
                    data-aos="fade"
                    data-aos-delay="1100"
                >
                    <p>· Você já começou a adequar os processos do seu RH?</p>
                    <p class="m2">
                        · Você sabe como elaborar o seu plano estratégico para
                        atender a lei e evitar multas?
                    </p>
                </div> -->
            </div>

            <div class="row-img">
                <img src="~@/assets/img/page1-img1.png" alt="" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ["scrolled"],
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page1 {
    height: 810px;
    position: relative;
    background-image: url("~@/assets/img/page1-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    
    .article {
        align-items: flex-start;
    }
    .article-blue {
        background-color: $color-cerulean;
        padding: 15px;
        padding-left: 20px;
    }

    .icons {
        flex-basis: 0;
        flex-grow: 1;
        padding-right: 20px;
        padding-left: 20px;
        img {
            max-width: 100%;
        }
    }

    .hideit {
        opacity: 0;
    }

    .arrow {
        cursor: pointer;
        transition: 0.5s;
        position: absolute;
        bottom: 3.2rem;
        margin-left: -25px;
        transform: translate(-50%, -12%);
        left: 50%;
        top: -12%;
        width: 60px;
        height: 60px;
        background-image: url("~@/assets/img/layout/arrow-down.png");
        background-repeat: no-repeat;
        background-size: contain;
        // padding-bottom: 50px;
    }

    .bounce {
        animation: bounce 2s infinite;
    }

    @keyframes bounce {
        0%,
        20%,
        50%,
        80%,
        100% {
            transform: translateY(-10px);
        }

        40% {
            transform: translateY(-25px);
        }

        60% {
            transform: translateY(-15px);
        }
    }
    @media (max-width: 1500px) {
        background-image: none;
        .main {
            justify-content: flex-start;
        }
        .column-text {
            justify-self: center;
            margin-left: 40px;
        }
        //    .row-img{
        //        margin-left: auto;
        //    }
    }
    @media (max-width: 950px) {
        background-image: none;
        padding-bottom: 30px;
        .column-text {
            padding-left: 30px;
        }
        .flex-row {
            flex-direction: column;
        }
        .breakpoint {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            text-align: left !important;
            img {
                max-width: 100%;
                height: 100px;
                width: 100px;
                padding-right: 10px;
            }
        }
    }
    @media (max-width: 700px) {
        padding-right: 20px;
        padding-left: 20px;
        background-image: none;
        padding-bottom: 30px;
        text-align: center !important;
        .arrow {
            transform: translate(-50%, -10%);
            left: 50%;
            top: -10%;
            width: 45px;
            height: 45px;
        }

        .icons {
            padding: 0;
        }
        .main {
            width: 100%;
        }
        .column-text {
            padding-left: 0;
            margin: 0;
        }
        .flex-row {
            flex-direction: column;
        }
        .breakpoint {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: left !important;
            img {
                max-width: 100%;
                height: 100px;
                width: 100px;
                padding-right: 10px;
            }
        }
    }
}
</style> 